const SIZE = {
    XS: 'xs',
    S: 's',
    M: 'm',
    L: 'l',
    XL: 'xl',
    '2XL': 'xxl',
    '3XL': 'xxxl',
    '4XL': 'xxxxl',
};

export { SIZE };
